import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilter2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFilter2"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V5.5H2V4ZM5 11.25H19V12.75H5V11.25ZM8 18.5H16V20H8V18.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFilter2;
